import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-your-price',
  templateUrl: './your-price.component.html',
  styleUrls: ['./your-price.component.css']
})
export class YourPriceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
